import { render, staticRenderFns } from "./PlateNumber.vue?vue&type=template&id=611fdd69&scoped=true&"
import script from "./PlateNumber.vue?vue&type=script&lang=js&"
export * from "./PlateNumber.vue?vue&type=script&lang=js&"
import style0 from "./PlateNumber.vue?vue&type=style&index=0&id=611fdd69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611fdd69",
  null
  
)

export default component.exports